import React from 'react'
import { Box, Typography, Divider, Grid, Chip } from '@mui/material'

export const UserProfile = (props) => {
  const { data } = props

  const profileRow = [
    {
      title: 'Name',
      info: data?.name,
    },
    { title: 'Email', info: `${data?.email}` },
    { title: 'Position', info: `${data?.position}` },
    { title: 'Employee ID', info: `${data?.employeeId}` },
    { title: 'Branch', info: `${data?.branch}` },
    { title: 'Department', info: `${data?.department}` },
  ]

  const renderChipDisplay = (data) => {
    if (data) {
      return (
        <Box py={1} gap={1} display='flex' flexWrap='wrap'>
          {data?.map((each, idx) => (
            <Chip label={each} key={idx} />
          ))}
        </Box>
      )
    }
  }

  return (
    <Box my={5}>
      {profileRow.map((eachRow, idx) => (
        <Box key={idx}>
          <Grid container py={1}>
            <Grid minWidth={150}>
              <Typography variant='h2' sx={{ fontSize: { xs: '14px', sm: '18px' } }}>
                {eachRow?.title}:
              </Typography>
            </Grid>
            <Grid>
              {eachRow.isChip ? (
                renderChipDisplay(eachRow?.info)
              ) : (
                <Typography variant='h4' sx={{ fontSize: { xs: '14px', sm: '18px' } }}>
                  {eachRow?.info}
                </Typography>
              )}
            </Grid>
          </Grid>
          <Divider />
        </Box>
      ))}
    </Box>
  )
}
